module.exports = __webpack_public_path__ + "img/hk1_global_bg.2cddfe9a.png";